<template>
  <span>
    <router-link
      v-if="computedObject && id"
      class="link"
      :to="{ name: 'contract-detail', params: { contractId: id } }"
    >
      {{ computedObject.receipt }}
      <font-awesome-icon
        class="icon"
        icon="external-link-alt"
      />
    </router-link>
    <span v-else>
      {{ emptyValue }}
    </span>
  </span>
</template>

<script lang="ts" setup>
import {computed} from 'vue'
import Contract from '@/types/api/contract.type'

interface Props {
  contract: Contract['id'] | Partial<Contract>
  emptyValue: string
}

const props = withDefaults(defineProps<Props>(), {
  emptyValue: '-',
})

const computedObject = computed(() => {
  let object = new Contract()
  if (typeof props.contract !== 'number')
    object = {...object, ...props.contract}
  // TODO case for only id
  return object
})

const id = computed(() => {
  return computedObject.value.id
})
</script>

<style scoped rel="stylesheet/scss">
.link:hover {
  @apply text-blue-kurz-500;
}
</style>
<style></style>
